var _rect, _path, _rect2, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1289.5 -5214V-5177H14775.5V-5214V-5251H-1289.5V-5214ZM14777.5 -5212H14740.5V1230H14777.5H14814.5V-5212H14777.5ZM14775.5 1232V1195H-1289.5V1232V1269H14775.5V1232ZM-1291.5 1230H-1254.5V-5212H-1291.5H-1328.5V1230H-1291.5ZM-1289.5 1232V1195C-1270.17 1195 -1254.5 1210.67 -1254.5 1230H-1291.5H-1328.5C-1328.5 1251.54 -1311.04 1269 -1289.5 1269V1232ZM14777.5 1230H14740.5C14740.5 1210.67 14756.2 1195 14775.5 1195V1232V1269C14797 1269 14814.5 1251.54 14814.5 1230H14777.5ZM14775.5 -5214V-5177C14756.2 -5177 14740.5 -5192.67 14740.5 -5212H14777.5H14814.5C14814.5 -5233.54 14797 -5251 14775.5 -5251V-5214ZM-1289.5 -5214V-5251C-1311.03 -5251 -1328.5 -5233.54 -1328.5 -5212H-1291.5H-1254.5C-1254.5 -5192.67 -1270.17 -5177 -1289.5 -5177V-5214Z",
    fill: "#76AEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 770,
    transform: "translate(-857.5 -335)",
    fill: "#F2F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-308.5 -157C-308.5 -163.627 -303.127 -169 -296.5 -169H446.5C453.127 -169 458.5 -163.627 458.5 -157V377C458.5 383.627 453.127 389 446.5 389H-296.5C-303.127 389 -308.5 383.627 -308.5 377V-157Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5965_30544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "#D1E4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 41,
    width: 187.428,
    height: 56.2283,
    rx: 12.4952,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2321 69.1141C87.2321 59.1078 79.1204 50.9961 69.1141 50.9961C59.1078 50.9961 50.9961 59.1078 50.9961 69.1141C50.9961 79.1204 59.1078 87.2321 69.1141 87.2321C79.1204 87.2321 87.2321 79.1204 87.2321 69.1141Z",
    fill: "#013B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6325 69.652C72.2861 69.1377 72.7632 68.4326 72.9973 67.6346C73.2315 66.8366 73.2111 65.9855 72.939 65.1996C72.6669 64.4137 72.1567 63.7322 71.4792 63.2499C70.8018 62.7675 69.9908 62.5083 69.1592 62.5083C68.3275 62.5083 67.5166 62.7675 66.8391 63.2499C66.1617 63.7322 65.6514 64.4137 65.3793 65.1996C65.1072 65.9855 65.0869 66.8366 65.321 67.6346C65.5552 68.4326 66.0322 69.1377 66.6858 69.652C65.5659 70.1007 64.5887 70.8449 63.8584 71.8052C63.1282 72.7656 62.6722 73.9062 62.5392 75.1053C62.5295 75.1928 62.5373 75.2814 62.5619 75.366C62.5865 75.4506 62.6275 75.5295 62.6826 75.5982C62.7939 75.737 62.9557 75.8258 63.1325 75.8453C63.3093 75.8647 63.4866 75.8132 63.6254 75.7019C63.7642 75.5906 63.8531 75.4288 63.8725 75.252C64.0189 73.9488 64.6403 72.7452 65.618 71.8712C66.5957 70.9971 67.8611 70.514 69.1725 70.514C70.4839 70.514 71.7493 70.9971 72.727 71.8712C73.7047 72.7452 74.3261 73.9488 74.4725 75.252C74.4906 75.4158 74.5688 75.5671 74.6919 75.6766C74.815 75.7862 74.9744 75.8463 75.1392 75.8453H75.2125C75.3873 75.8252 75.547 75.7368 75.6569 75.5995C75.7668 75.4621 75.8179 75.2869 75.7992 75.112C75.6655 73.9094 75.2071 72.766 74.4731 71.8041C73.7391 70.8422 72.7571 70.0983 71.6325 69.652ZM69.1592 69.1786C68.6318 69.1786 68.1162 69.0222 67.6777 68.7292C67.2391 68.4362 66.8973 68.0197 66.6955 67.5325C66.4937 67.0452 66.4409 66.509 66.5437 65.9917C66.6466 65.4744 66.9006 64.9993 67.2736 64.6263C67.6465 64.2534 68.1217 63.9994 68.6389 63.8965C69.1562 63.7936 69.6924 63.8465 70.1797 64.0483C70.6669 64.2501 71.0834 64.5919 71.3764 65.0304C71.6694 65.469 71.8258 65.9845 71.8258 66.512C71.8258 67.2192 71.5449 67.8975 71.0448 68.3976C70.5447 68.8977 69.8664 69.1786 69.1592 69.1786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2285,
    y: 59.1182,
    width: 81.2613,
    height: 7.49711,
    rx: 3.74855,
    fill: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2285,
    y: 71.6133,
    width: 101.056,
    height: 7.49711,
    rx: 3.74855,
    fill: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 102.227,
    width: 187.428,
    height: 56.2283,
    rx: 12.4952,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2321 130.341C87.2321 120.334 79.1204 112.223 69.1141 112.223C59.1078 112.223 50.9961 120.334 50.9961 130.341C50.9961 140.347 59.1078 148.459 69.1141 148.459C79.1204 148.459 87.2321 140.347 87.2321 130.341Z",
    fill: "#013B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6325 130.879C72.2861 130.364 72.7632 129.659 72.9973 128.861C73.2315 128.063 73.2111 127.212 72.939 126.426C72.6669 125.64 72.1567 124.959 71.4792 124.476C70.8018 123.994 69.9908 123.735 69.1592 123.735C68.3275 123.735 67.5166 123.994 66.8391 124.476C66.1617 124.959 65.6514 125.64 65.3793 126.426C65.1072 127.212 65.0869 128.063 65.321 128.861C65.5552 129.659 66.0322 130.364 66.6858 130.879C65.5659 131.327 64.5887 132.071 63.8584 133.032C63.1282 133.992 62.6722 135.133 62.5392 136.332C62.5295 136.419 62.5373 136.508 62.5619 136.593C62.5865 136.677 62.6275 136.756 62.6826 136.825C62.7939 136.964 62.9557 137.052 63.1325 137.072C63.3093 137.091 63.4866 137.04 63.6254 136.928C63.7642 136.817 63.8531 136.655 63.8725 136.479C64.0189 135.175 64.6403 133.972 65.618 133.098C66.5957 132.224 67.8611 131.741 69.1725 131.741C70.4839 131.741 71.7493 132.224 72.727 133.098C73.7047 133.972 74.3261 135.175 74.4725 136.479C74.4906 136.642 74.5688 136.794 74.6919 136.903C74.815 137.013 74.9744 137.073 75.1392 137.072H75.2125C75.3873 137.052 75.547 136.963 75.6569 136.826C75.7668 136.689 75.8179 136.513 75.7992 136.339C75.6655 135.136 75.2071 133.993 74.4731 133.031C73.7391 132.069 72.7571 131.325 71.6325 130.879ZM69.1592 130.405C68.6318 130.405 68.1162 130.249 67.6777 129.956C67.2391 129.663 66.8973 129.246 66.6955 128.759C66.4937 128.272 66.4409 127.736 66.5437 127.218C66.6466 126.701 66.9006 126.226 67.2736 125.853C67.6465 125.48 68.1217 125.226 68.6389 125.123C69.1562 125.02 69.6924 125.073 70.1797 125.275C70.6669 125.477 71.0834 125.818 71.3764 126.257C71.6694 126.696 71.8258 127.211 71.8258 127.739C71.8258 128.446 71.5449 129.124 71.0448 129.624C70.5447 130.124 69.8664 130.405 69.1592 130.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2285,
    y: 120.345,
    width: 81.2613,
    height: 7.49711,
    rx: 3.74855,
    fill: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2285,
    y: 132.84,
    width: 101.056,
    height: 7.49711,
    rx: 3.74855,
    fill: "#F0F6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5965_30544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/groupIcon.f7c23891f705f24cfcd59bf8648b5e94.svg";
export { ForwardRef as ReactComponent };